(function ($) {
  let test = " test";
  let breadcrumbobject;
  function breadcrumbStateSaver(text, link) {
    if (typeof Storage != 'undefined') {
      if (sessionStorage.breadcrumb) {
        sessionStorage.breadcrumb = sessionStorage.breadcrumb + ';' + text;
        sessionStorage.locations = sessionStorage.locations + ';' + link; //use any delim you prefer
      } else {
        sessionStorage.breadcrumb = text;
        sessionStorage.locations = link;
      }
    }
    let uniqueURLs = [...new Set(sessionStorage.locations)]
  }
  function breadcrumbOrginazation(link, text) {

  }
  function showBreadCrumb() {
    let crumbs = sessionStorage.breadcrumb.split(';');
    let links = sessionStorage.locations.split(';');
    let uniqueLinks = [...new Set(links)];
    let uniqueCrumbs = [...new Set(crumbs)];
    // let links = uniqueURLs.split(';');
    let crumbindex = parseInt(sessionStorage.crumbindex);
    for (let index in uniqueCrumbs) {
      $('#navigation_links').append(
        $(
          "<li><a class='crumb" +
            (index == crumbindex ? 'active' : '') +
            "' href='" +
            uniqueLinks[index] +
            "' data-node='" +
            index +
            "'>" +
            uniqueCrumbs[index] +
            '</a></li>'
        )
      ); //data-node will help in retrieving the index and class will be set to active for selected node
    }
  }
  
  $(document).ready(function(){
    console.log('breadcrumb');
  $('#navigation_links').on('click', 'li a.crumb', function(){
      if (typeof (Storage) != "undefined") {
          sessionStorage.crumbindex = $(this).data('node');
          sessionStorage.navlinkclicked = "true"; //This will prevent from adding breadcrumb again
      }
  });
  breadcrumbStateSaver(document.title, document.location.href);
  showBreadCrumb();
});
})(jQuery);


